export const ChevronLeftIcon = () => (
	// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g id="tdesign:chevron-left">
			<path
				id="Vector"
				d="M15.9141 17.5L10.4141 12L15.9141 6.5L14.5001 5.086L7.58606 12L14.5001 18.914L15.9141 17.5Z"
				fill="#22082B"
			/>
		</g>
	</svg>
);
